import axios from "axios";
import { smartsightAPI } from "../constants/defaultValues";

const API = axios.create({
  baseURL: smartsightAPI
});

export default API;
